import { API_CONFIG } from '../lib/apiConfig';
import { createPngMetaOverlayHook } from '../lib/hookFactories';

/**
 * Finds the precomputed WHP PNG overlay + geographic bounds for a given
 * (mill, drive_time). The hook only fetches the small `.meta.json` sidecar;
 * Leaflet's ImageOverlay loads the PNG bytes itself when rendered.
 */
export const useWhpOverlay = createPngMetaOverlayHook({
  metaPath: API_CONFIG.s3.paths.whpOverlayMeta,
  pngPath: API_CONFIG.s3.paths.whpOverlay,
});
